export enum FreeTextCategory {
    Inclusion = 'Inclusion',
    Bespoke = 'Bespoke',
    Engagement = 'Engagement',
}

export type FreeTextTableStyleProps = {
    size: 'small' | 'medium'
}
